export default __webpack_public_path__ + "static/media/arrow-left.d364dc4b.svg";